import {createSlice} from '@reduxjs/toolkit'
const filterProductCondition = createSlice({
  name: 'filterProductCondition',
  initialState: 'new' as string,
  reducers: {
    productConditionFilterdata(state: any, action: any) {
      return action?.payload || 'new'
    },
  },
})
export default filterProductCondition.reducer
export const {productConditionFilterdata} = filterProductCondition.actions
